import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import cartIcon from './cart-icon.svg';
import ReleaseDownloadLink from '../../ReleaseDownloadLink';
import '../../../shared-styles/card.scss';
import './styles.scss';
import ExternalTrial from '../../../web-common/models/accounts/ExternalTrial';
import UserProductSummary from '../../../web-common/models/accounts/UserProductSummary';
import formatDate from '../../../web-common/utils/formatDate';

interface ProductDownloadProps {
  trial?: ExternalTrial;
  productSummary?: UserProductSummary;
}

export default class ProductDownload extends Component<ProductDownloadProps> {

  render() {

    const { trial } = this.props;
    if (trial) {
      const { expired } = trial;
      const versionInfo = expired ? '' : `• ${trial.version}`;
      return (
        <div className={`product-download card-without-hover ${expired ? 'expired-trial' : 'active-trial'}`}>
          <div>
            <div className="releases-link">
              <h2><span className="title-highlight">{expired ? 'Expired' : 'Free'} trial:</span> {trial.name}</h2>
              <div>{expired ? 'Ended' : 'Ends'} {formatDate(trial.endDateTime)} {versionInfo}</div>
              <a className="buy-link" href={trial.productStoreUrl}>
                <img src={cartIcon}></img>
                <span>{expired ? 'Buy now' : 'Buy'}</span>
              </a>
            </div>
            <div className="download-options">
              {!expired && <ReleaseDownloadLink downloadLinkUrl={trial.downloadLinkUrl}>Download trial</ReleaseDownloadLink>}
            </div>
          </div>
        </div>
      );
    }

    const { productSummary } = this.props;
    return (
      <div className="product-download card">
        <div>
          <Link to={`/products/${productSummary!.id}`} className="releases-link">
            <h2>{productSummary!.name}</h2>
            <div>See all releases</div>
          </Link>
          <div className="download-options">
            {this._renderLatestReleaseLink()}
          </div>
        </div>
      </div>
    );
  }

  private _renderLatestReleaseLink() {

    const release = this.props.productSummary!.releases[0];
    if (release) {
      return <ReleaseDownloadLink downloadLinkUrl={release.downloadLinkUrl}>Download latest</ReleaseDownloadLink>;
    }
  }
}
